<template>
  <div :class="`announce-screen ${isRestrictFunc ? 'open' : 'close'}`">
    <section class="announce-screen__contents-wrapper">
      <h5>{{ restrictFuncInfo.name }}</h5>
      <h2>본 기능은 {{ isWhitePlan ? '유료' : '블랙' }} 플랜에서만 제공됩니다.</h2>
      <p>
        {{ restrictFuncInfo.message }}
      </p>
      <a
        href="#"
        @click.prevent="handleClickPlanBuyButton"
      >
        {{ isWhitePlan ? '유료 플랜 결제' : '블랙 플랜으로 업그레이드' }}
      </a>
      <button @click.prevent="handleClose">
        닫기
      </button>
    </section>
  </div>
</template>

<script>
import { computedGetters } from '@/utils/vuex-helper';
export default {
  name: 'RestrictAnnounceScreen',
  computed: {
    ...computedGetters([
      'isRestrictFunc',
      'restrictFuncInfo',
      'isWhitePlan',
      'isGreyPlan',
      'isLightGreyPlan'
    ])
  },
  methods: {
    handleClickPlanBuyButton() {
      let link = '';
      if (this.isWhitePlan) {
        link = 'https://form.typeform.com/to/bVi26J?utm_source=';
      } else if (this.isGreyPlan || this.isLightGreyPlan) {
        link = 'https://form.typeform.com/to/Q8HsPXfT?utm_source=';
      } else {
        return;
      }
      window.open(link + this.restrictFuncInfo.id);
    },
    handleClose() {
      this.$store.commit('setIsRestrictFunc', false);
    }
  }
};
</script>

<style lang="scss" scoped>
.announce-screen {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  overflow: hidden;
  backdrop-filter: blur(5px);
  background-color: rgba(221, 221, 221, 0.23);

  &.open {
    display: flex;
  }
  &.close {
    display: none;
  }

  .announce-screen__contents-wrapper {
    display: flex;
    flex-direction: column;
    color: #202020;
    text-align: center;
    margin: auto;
    width: 420px;
    h5 {
      margin: auto auto 10px auto;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: -0.7px;
      text-align: center;
    }

    h2 {
      margin: auto auto 15px auto;
      font-size: 24px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: -1.5px;
      text-align: center;
    }

    p {
      margin: auto auto 30px auto;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: -0.8px;
      text-align: center;
      word-break: keep-all;
    }

    a {
      box-sizing: border-box;
      width: 350px;
      height: 50px;
      margin: auto auto 5px auto;
      padding: 14px 0;
      border-radius: 4px;
      background-color: #d3d3d3;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: -0.5px;
      text-align: center;
      color: #4a4a4a;
    }
    button {
      cursor: pointer;
      margin: auto;
      width: 350px;
      height: 50px;
      border: none;
      background-color: inherit;
      font-size: 15px;
    }
  }
  @media screen and (max-width: 768px) {
    .announce-screen__contents-wrapper {
      width: 300px;
      h5 {
        font-size: 14px;
      }

      h2 {
        font-size: 20px;
      }

      p {
        font-size: 14px;
      }

      a {
        box-sizing: border-box;
        width: 295px;
        height: 50px;
      }

      button {
        width: 295px;
      }
    }
  }
}
</style>
